<div fxLayout="row" fxLayout.lt-md="column">
    <app-trend-metric fxFlex="75%" fxFlex.lt-md="auto" fxLayout="column"></app-trend-metric>
    <app-alert-metric fxFlex="25%" fxFlex.lt-md="auto" fxLayout="column"></app-alert-metric>
</div>